import React from 'react';
import propTypes from 'prop-types';
import TableRow from './TableRow';
import Header from './Header';
import './index.css';

const styles = {
    tableWrapper: {
        minWidth: '800px',
        width: '100%',
        height: '75%',
        boxSizing: 'border-box',
        overflow: 'auto',
        maxHeight: 'calc(100vh - 350px)',
        borderRadius: '20px'
    },
    table: {
        width: '100%',
        tableLayout: 'fixed',
        borderCollapse: 'collapse',
        borderSpacing: '0',

    },
    tableBody: {
        borderRadius: '20px'
    },
};

const HistoryTable = ({
                          conversationsList,
                          selectedClientIds,
                          selectedOperatorsIds,
                          selectedChannel,
                          selectedStatuses,
                          selectedCustomer,
                          handleFilterChange,
                          showConversationHistory,
                          company,
                          language,
                          startDate,
                          endDate,
                          handleDateChange,
                          handleUserKeySearch,
                          openTrModal,
                          user
                      }) => {

    return (
        <div style={styles.tableWrapper}>
            <table className={'history-table'} style={styles.table}>
                <Header
                    user={user}
                    handleUserKeySearch={handleUserKeySearch}
                    company={company}
                    handleFilterChange={handleFilterChange}
                    selectedStatuses={selectedStatuses}
                    selectedOperatorsIds={selectedOperatorsIds}
                    selectedClientsIds={selectedClientIds}
                    selectedChannel={selectedChannel}
                    selectedCustomer={selectedCustomer}
                    language={language}
                    startDate={startDate}
                    endDate={endDate}
                    handleDateChange={handleDateChange}
                    conversations={conversationsList}
                />
                <tbody style={styles.tableBody}>
                {conversationsList.map((conversation) => {
                    return <TableRow
                        key={conversation.id}
                        conversation={conversation}
                        showConversationHistory={showConversationHistory}
                        company={company}
                        openTrModal={openTrModal}
                    />;
                })}
                </tbody>
            </table>
        </div>
    );
};

HistoryTable.propTypes = {
    company: propTypes.object.isRequired,
    conversationsList: propTypes.array.isRequired,
    showConversationHistory: propTypes.func.isRequired,
    handleFilterChange: propTypes.func.isRequired,
    selectedClientIds: propTypes.array.isRequired,
    selectedOperatorsIds: propTypes.array.isRequired,
    selectedChannel: propTypes.array.isRequired,
    selectedCustomer: propTypes.string.isRequired,
    language: propTypes.string.isRequired,
    startDate: propTypes.object.isRequired,
    endDate: propTypes.object.isRequired,
    handleDateChange: propTypes.func.isRequired,
};

export default HistoryTable;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/history/HistoryTable.jsx